import { Text, Flex, Metric } from "@tremor/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThermometerHalf,
  faSignal,
  faBatteryThreeQuarters,
  faWater,
  faSun,
  faSatelliteDish,
  faWind,
  faTachometerAlt,
  faRuler,
  faCloud,
  faCompass,
  faLeaf,
  faBolt,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

export default function Value({ highlight, capability }) {
  const formatNumberValue = (value) => {
    if (typeof value === "string" && !isNaN(value)) {
      value = parseFloat(value);
    }

    if (typeof value !== "number" || isNaN(value)) {
      return value;
    }

    return value.toFixed(2);
  };

  // Map capability types to FontAwesome icons
  const getIconForCapabilityType = (type) => {
    const iconMap = {
      temp: faThermometerHalf,
      temperature: faThermometerHalf,
      rssi: faSignal,
      snr: faSatelliteDish,
      voltage: faBatteryThreeQuarters,
      battery: faBatteryThreeQuarters,
      rel_hum: faWater,
      humidity: faWater,
      relative_humidity: faWater,
      barometric_pressure: faTachometerAlt,
      luminocity: faSun, 
      light: faSun,
      wind: faWind,
      pressure: faTachometerAlt,
      distance: faRuler,
      rain: faCloud,
      direction: faCompass,
      co2: faLeaf,
      power: faBolt,
      analog_sensor: faExclamationTriangle,
    };

    return iconMap[type] || faExclamationTriangle;
  };

  const icon = getIconForCapabilityType(capability.type);

  return (
    <>
      <Flex justifyContent="center" alignItems="center" className="mt-2">
        <FontAwesomeIcon icon={icon} className="w-6 h-6 mr-2" />
        <Metric className="text-4xl">
          {formatNumberValue(capability.value)}
        </Metric>
        <Text className="text-sm ml-2 mt-3">{capability.unit}</Text>
      </Flex>
    </>
  );
}
